import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {Store} from '@ngrx/store';
import {DataSurveyState} from '../../store/reducers/data-survey.reducers';
import {ParticleService} from '@core/services/particle.service';
import {take, takeUntil} from 'rxjs/operators';
import {CreateCustomFormCommand, DeleteSurveyCommand} from '../../commands/survey.commands';
import {DeleteSurveyAction} from '../../store/actions/data-survey.actions';
import {Guid} from 'guid-typescript';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-data-survey-forms',
  templateUrl: './data-survey-forms.component.html',
  styleUrls: ['./data-survey-forms.component.scss']
})
export class DataSurveyFormsComponent implements OnInit, OnDestroy {

  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  ngUnsubscribe: Subject<void> = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  constructor(private router: Router,
              private dialogService: DialogService,
              private commandService: CommandService,
              private dataSurveyStore: Store<DataSurveyState>,
              private activatedRoute: ActivatedRoute,
              private particleService: ParticleService) {
    this.sourceKey = 'Data-Survey-Forms';
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id : 'DataSurvey',
        title: 'Data Surveys',
        type: 'DataSurvey',
        relativeUrl: 'data-survey'
      },
      <BreadcrumbModel>{
        id : 'DataSurveyForm',
        title: 'Forms',
        type: 'DataSurveyForm',
        relativeUrl: 'data-survey/forms'
      }
    ];
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {

  }

  onGridCellValueChange($event) {
    console.log($event);
    if ($event.fieldDefinition && $event.item.cells[$event.fieldDefinition.key].value) {
      this.router.navigateByUrl(`data-survey/forms/design/${$event.item.id}`);
    }
  }
  addSurvey() {

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createForm() {
    const dialogModel = DialogModel.create('Create Form', 'CreateCustomFormDialogComponent', {title: '', viewType : 'Group'}
      , '800px');
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(take(1)).subscribe(state => {
      if (state.action === 'OK') {
        this.commandService.executeCommand(new CreateCustomFormCommand(state.data.input.title, state.data.input.viewType))
          .pipe(take(1)).subscribe(commandState => {
            console.log('CreateCustomFormDialogComponent: Command ', commandState);
          this.router.navigateByUrl(`data-survey/forms/design/${commandState.Payload.Id}`);
        });
      }
    });
  }
}

